<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-text-field v-model="fields.title" :hide-details="true" />
        </div>

        <div class="mb-5">
          <label class="label-input">Layout</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6">
                <label>Background Section</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['card-container']"
                    @change="event => (fields['card-container'] = event.target.value)"
                  />
                  <v-text-field v-model="fields['card-container']" :hide-details="true" class="mt-0" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <label>Text Color</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['text-color']"
                    @change="event => (fields['text-color'] = event.target.value)"
                  />
                  <v-text-field v-model="fields['text-color']" :hide-details="true" class="mt-0" />
                </div>
              </v-col>
              <v-col cols="12" md="12">
                <v-checkbox v-model="fields['top-padding']" label="Padding top" :hide-details="true" class="mb-2" />
                <v-checkbox
                  v-model="fields['bottom-padding']"
                  label="Padding bottom"
                  :hide-details="true"
                  class="mb-2"
                />
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-5">
          <label class="label-input">Title Section</label>
          <div class="group-item">
            <v-checkbox
              v-model="fields['title-card'].show"
              label="Show title block"
              :hide-details="true"
              class="mb-2 mt-0"
            />
            <ckeditor
              v-if="fields['title-card'].show"
              :editor="editor"
              v-model="fields['title-card'].content"
              :config="editorConfig"
            />
          </div>
        </div>

        <div class="mb-5">
          <label class="label-input">Heading Block</label>
          <div class="group-item">
            <UploadImage
              @callback="obj => (fields['image-heading'] = obj.imageSrc)"
              :image="{ imageSrc: fields['image-heading'] }"
              :height="`180`"
              :typeUpload="'image'"
              @callbackDelete="() => (fields['image-heading'] = '')"
            />
            <div class="mt-4">
              <label class="mb-2 d-block">Heading Content</label>
              <ckeditor :editor="editor" v-model="fields['text-heading']" :config="editorConfig" />
            </div>
            <v-checkbox
              v-model="fields['highlight-text'].show"
              label="Show highlight text"
              :hide-details="true"
              class="mb-2 mt-4"
            />
            <div>
              <div>Highlight text</div>
              <v-text-field
                v-if="fields['highlight-text'].show"
                v-model="fields['highlight-text'].content"
                :hide-details="true"
              />
            </div>
          </div>
        </div>

        <div class="mb-5">
          <label class="label-input">Content Block</label>
          <div class="group-item">
            <UploadImage
              @callback="obj => (fields['image-content'] = obj.imageSrc)"
              :image="{ imageSrc: fields['image-content'] }"
              :height="`180`"
              :typeUpload="'image'"
              @callbackDelete="() => (fields['image-content'] = '')"
            />
            <div class="mt-4">
              <label class="mb-2 d-block">Content List</label>
              <ckeditor :editor="editor" v-model="fields['text-content']" :config="editorConfig" />
            </div>
          </div>
        </div>

        <div class="mb-5">
          <label class="label-input">Button</label>
          <div class="group-item">
            <v-checkbox v-model="fields.button.show" label="Show button" :hide-details="true" class="mb-2 mt-0" />
            <v-row v-if="fields.button.show">
              <v-col cols="12" md="6">
                <label>Button text</label>
                <v-text-field v-model="fields.button.text" :hide-details="true" />
              </v-col>
              <v-col cols="12" md="6">
                <label>Button link</label>
                <v-text-field v-model="fields.button.link" :hide-details="true" />
              </v-col>
              <v-col cols="12" md="6">
                <label>Background</label>
                <input
                  type="color"
                  style="width: 100%; height: 40px"
                  :value="fields.button.background"
                  @change="event => (fields.button.background = event.target.value)"
                />
              </v-col>
              <v-col cols="12" md="6">
                <label>Text Color</label>
                <input
                  type="color"
                  style="width: 100%; height: 40px"
                  :value="fields.button.color"
                  @change="event => (fields.button.color = event.target.value)"
                />
              </v-col>
            </v-row>
          </div>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '../common/html/update';
import UploadImage from '../common/form/upload-file/upload-image.vue';

const getDefaultFields = () => ({
  title: 'Grid Item Kynorelle 05 Section',
  'top-padding': true,
  'bottom-padding': true,
  'card-container': '#FFFFFF',
  'text-color': '#000000',
  'title-card': {
    show: true,
    content:
      '<h2>Made For Real Comfort, Every Day</h2><p>Designed for women who want comfort that actually lasts all day.</p>',
  },
  'image-heading': '',
  'text-heading': '<h2>Reason Why kynorelle Isnt Like Any Youve Worn Before</h2><p>Lorem ipsum dolor sit amet.</p>',
  'highlight-text': {
    show: true,
    content: 'Leggings that feel tight slip and need constant adjusting.',
  },
  'image-content': '',
  'text-content':
    '<ul><li>Most only work for a while.</li><li>Kynorelle is made for the whole day.</li><li>No rolling, No pressure, No adjusting</li><li>Just all-day comfort</li></ul>',
  button: {
    show: true,
    text: 'SHOP NOW',
    link: '#',
    background: '#003568',
    color: '#ffffff',
  },
});

export default {
  name: 'GridItemKynorelle05SectionEditor',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: getDefaultFields(),
    };
  },
  mounted() {
    const sectionExtract = this.sectionEditor.sectionExtract || {};
    this.fields = {
      ...getDefaultFields(),
      ...sectionExtract,
      'title-card': {
        ...getDefaultFields()['title-card'],
        ...(sectionExtract['title-card'] || {}),
      },
      'highlight-text': {
        ...getDefaultFields()['highlight-text'],
        ...(sectionExtract['highlight-text'] || {}),
      },
      button: {
        ...getDefaultFields().button,
        ...(sectionExtract.button || {}),
      },
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionGridItemKynorelle05(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.group-item {
  border: 1px solid #0000000f;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
}
.ck-editor__editable_inline {
  min-height: 180px;
}
.ck-editor__editable {
  min-height: 180px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
